exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".align-center-horizontally {\n  display: flex;\n  justify-content: center; }\n\n.align-center {\n  display: flex;\n  display: -ms-flexbox;\n  justify-content: center;\n  align-items: center; }\n\n.login-form {\n  top: 33rem; }\n\n.login_form {\n  width: 400px;\n  margin: auto;\n  padding-top: 2rem; }\n\n.download_app h3 {\n  font-weight: 600;\n  font-size: 22px; }\n\n.download_img img {\n  width: 25%;\n  opacity: 0.9;\n  margin: auto; }\n\n.crs-pointer {\n  cursor: pointer; }\n\n.password-warning-section {\n  margin-left: 22px;\n  margin-bottom: 2px; }\n\n.password-warning-section-margin-bottom-10 {\n  margin-bottom: 10px !important; }\n\n.success-message-section {\n  color: green;\n  font-weight: bold;\n  text-align: center; }\n\n.error-message-section {\n  color: red;\n  font-weight: bold;\n  text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/verify_2FA_code/verify_2FA_code.scss
// module id = 1194
// module chunks = 1